import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { profileData } from '@/mocks/profile';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50" role="contentinfo">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50 hover:text-primary-400 transition-colors">
              佐佐木明希
            </Link>
            <p className="mt-4 text-sm text-background-50/60 leading-relaxed">
              汇聚佐佐木明希最新动态、个人资料、作品精选与粉丝社区，带你全面了解她的魅力世界。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {profileData.socialLinks.twitter && (
                <a href={profileData.socialLinks.twitter} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
              )}
              {profileData.socialLinks.instagram && (
                <a href={profileData.socialLinks.instagram} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="Instagram">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              )}
              {profileData.socialLinks.youtube && (
                <a href={profileData.socialLinks.youtube} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="YouTube">
                  <i className="ri-youtube-line text-sm"></i>
                </a>
              )}
              {profileData.socialLinks.weibo && (
                <a href={profileData.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><Link to="/about#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系我们</Link></li>
              <li><Link to="/category/events" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">活动信息</Link></li>
              <li><Link to="/category/community" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">粉丝社区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@sasakinoaki-fans.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>日本东京都港区赤坂1-12-32<br />ARK Hills 15F</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>+81 3-1234-5678</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">© 2026 佐佐木明希官方粉丝站. All rights reserved. 本网站为非营利性粉丝应援站点。</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}